import { css } from '@bts-web/utils-style-engine';
import { RegularAed, RegularEuro, RegularUsd } from '../../common/svgIcons';

const iconStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'neutrals.fill_primary',
  height: '40px',
  width: '40px',
  borderRadius: '50px',
});

export const IconMapper = {
  AED: (
    <RegularAed
      className={iconStyle}
      size={28}
      width={40}
      height={40}
      color="neutrals.text_primary_inverted"
    />
  ),
  EUR: (
    <RegularEuro
      className={iconStyle}
      size={28}
      width={40}
      height={40}
      color="neutrals.text_primary_inverted"
    />
  ),
  USD: (
    <RegularUsd
      className={iconStyle}
      size={28}
      width={40}
      height={40}
      color="neutrals.text_primary_inverted"
    />
  ),
};

export type TradeAssetSelectorTranslations = {
  cash: string;
  allAssets: string;
  get: string;
  payWith: string;
  all: string;
  sell: string;
  available: string;
  price: string;
  select_asset: string;
  continue: string;
  buy: string;
  assetUnavailable: string;
  paymentMethod: string;
  onlineTransfer: string;
  details: string;
  account: string;
  bankAccountHolder: string;
  bankName: string;
  onlineTransferSubtitle: string;
  onlineTransferNameWarning: string;
  onlineTransferContactSupport: string;
  onlineTransferContactTitle: string;
  onlineTransferPhone: string;
  onlineTransferEmail: string;
  deposit: string;
  fee: string;
  total: string;
};

const tradeAssetSelectorTranslations: TradeAssetSelectorTranslations = {
  allAssets: 'currency_filter_all_assets',
  cash: 'cash',
  get: 'get',
  payWith: 'pay_with',
  all: 'all',
  sell: 'sell',
  available: 'available',
  price: 'price',
  select_asset: 'choose_asset',
  continue: 'continue',
  buy: 'buy',
  assetUnavailable: 'info_toast_asset_unavailable_title',
  paymentMethod: 'payment_method',
  onlineTransfer: 'online_transfer',
  details: 'details',
  account: 'account',
  bankAccountHolder: 'bank_account_holder',
  bankName: 'bank_name',
  onlineTransferSubtitle: 'online_transfer_subtitle',
  onlineTransferNameWarning: 'online_transfer_name_warning',
  onlineTransferContactSupport: 'online_transfer_contact_support',
  onlineTransferContactTitle: 'online_transfer_contact_title',
  onlineTransferPhone: 'phone',
  onlineTransferEmail: 'common_email',
  deposit: 'deposit',
  fee: 'fee',
  total: 'total',
};

export const getTradeAssetSelectorTranslations = (
  transUtil: (param: string) => string,
): TradeAssetSelectorTranslations => {
  return Object.entries(tradeAssetSelectorTranslations).reduce(
    (acc, [key, value]) => {
      acc[key as keyof TradeAssetSelectorTranslations] = transUtil(value);

      return acc;
    },
    {} as TradeAssetSelectorTranslations,
  );
};
